module.exports = __webpack_public_path__ + "resource/img/image057.d0cca014.png";